module.exports = __webpack_public_path__ + "static/media/home_page.ea6a274d.jpg";